<app-page-layout [title]="pageConfig.title" [subtitle]="pageConfig.subtitle || ''"
    [actions]="pageConfig.headerActions || []"
    breadcrumbKey="employeeManagement"
    (actionClicked)="onHeaderAction($event)">

    <!-- Main Content Table -->
    <div page-content>
        <app-dynamic-table [data]="tableColumns.length ? employeeState.filteredEmployees() : []" [columns]="tableColumns" [actions]="tableActions"
            [selectable]="true" [(selection)]="selectedEmployees" (bulkDelete)="deleteSelectedEmployees()"
            [exportConfig]="exportConfig" [showColumnSelector]="true" [strictColumnDefaults]="true" (actionClicked)="onTableAction($event)"
            [filters]="filterConfigs" [loading]="employeeState.loading() || !tableColumns.length"
            (primaryClick)="viewEmployee($event)" [emptyMessage]="emptyTableMessage()">

        </app-dynamic-table>
    </div>

</app-page-layout>



<!-- CSV Import Dialog -->
<app-csv-import-dialog [(visible)]="isImportDialogOpen" [importConfig]="importConfig" [moduleConfig]="employeeState.registrationConfig()"
    (importReady)="onImportReady($event)">
</app-csv-import-dialog>
